

























import Vue from "vue";
import { Component, Watch, Emit, Prop } from "vue-property-decorator";
import './simplemodal.less';

import {Validations} from 'vuelidate-property-decorators';
import { required,email } from 'vuelidate/lib/validators';

import $ from 'jquery';

@Component({
  components: {
  }
})
export default class NewPassword extends Vue {
    public email = '';

  mounted() {
    
  }

  @Validations()
    validations = {
        email: {required,email},
    }

    show(){
      $('#newpassword').modal('show');
    }
    hide(){
      $('#newpassword').modal('hide');
    }
    getpassword(){
      this.sendform(this.email);
    }
  @Emit('send')
    sendform(email){

    }


}
